var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "Edit" },
    [
      _c(
        "el-header",
        { staticClass: "Edit-header" },
        [
          _c("el-page-header", {
            attrs: { content: "查看创意" },
            on: { back: _vm.close }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("DetailTemplate", { attrs: { referer: "idea", id: _vm.id } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-534d67ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-534d67ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/idea/Detail.vue
// module id = 3jpZ
// module chunks = 1